import React from 'react';
import { Card, Flex, Rate, Modal, Form, Select, message } from 'antd';
import { EyeOutlined, EllipsisOutlined, EditOutlined, PhoneOutlined, LinkOutlined } from '@ant-design/icons';
import getCurrentShop from './get-current-shop';
import { openWxminiShop } from './tools';

const imageUrlPrefix = '//img.yxdj.tech/';

export default ({content, ...otherProps}) => {
    const {
        shopId,
        accId,
        title,
        logoUrl,
        shopType,
        status,
        contactPhoneNo,
        description,
        score,
    } = content;

    const [curruntShop, setCurruntShop] = React.useState(null);
    const [currentShopId, setCurrentShopId] = React.useState(null);
    
    React.useEffect(() => {
        const fetchShop = async () => {
            const shop = await getCurrentShop();
            setCurruntShop(shop);
            setCurrentShopId(shop ? shop.shopId : null);
        };
        
        fetchShop();
    }, []);
    
    const [levels, setLevels] = React.useState([]);
    const [levelForm] = Form.useForm();

    const { level, onChange } = otherProps;

    React.useEffect(() => {
        getLevels();
    }, []);

    const CardHeader = props => {
        return (
            <Flex justify="space-between">
                <Flex gap={10}>
                    <img style={{width: 30, height: 30}} src={`${imageUrlPrefix}${logoUrl}?x-oss-process=image/resize,w_200`} alt="" />
                    <div style={{lineHeight: '30px'}}>{title}</div>
                </Flex>
                <Flex gap={10} align='center'>
                    {/* <div><QrcodeOutlined /></div>
                    <a href="" target="_blank"><LinkOutlined /></a> */}
                </Flex>
            </Flex>
        )
    }

    const editLevel = async (levelId, partnerId, shopId ) => {
    
        Modal.confirm({
            title: '选择等级',
            content: (
                <Form form={levelForm}>
                    <Form.Item label="等级" layout='vertical' name="levelId">
                        <Select options={levels} defaultValue={levelId} />
                    </Form.Item>
                </Form>
            ),
            onOk() {
                console.log('OK');
                return requestEditLevel(levelForm.getFieldValue('levelId'), partnerId, shopId);
            },
            onCancel() {
                console.log('Cancel');
            },
        });
    }

    // 获取等级列表
    const getLevels = async () => {
        const response = await fetch('/api/shop/level-partner/list');
        const result = await response.json();

        if(result && result.success) {
            result.data = result.data.map(item => {
                return {
                    label: item.title,
                    value: item.id
                }
            });
            setLevels(result.data);
        }
    }

    const requestEditLevel = async ( levelId, partnerId, shopId) => {
        const response = await fetch(`/api/shop/partner/level-edit`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                partnerId,
                levelId,
                shopId,
            }),
        });
        const result = await response.json();

        if(result && result.success) {
            message.success({
                content: '修改成功',
            });
            onChange?.();
        } else {
            message.error({
                content: result.message,
            });
        }
    }

    return (
        <Card title={<CardHeader />} style={{minWidth: 360, maxWidth: 456, width: '100%'}}
            actions={[
                <a onClick={() => openWxminiShop(accId, shopId)}><EyeOutlined key="edit" /> 查看店铺</a>,
                <a onClick={() => editLevel(level.id, shopId, currentShopId)}><EditOutlined /> 修改代理等级</a>,
            ]}
        >
            <Flex justify="" align="left" gap={10}>
            {/* <img style={{ width: 50, height: 50}} src="https://gw.alipayobjects.com/zos/rmsportal/KDpgvguMpGfqaHPjicRK.svg" alt="Ant Design" /> */}
                <div>
                    <div>店铺名称：{title || '默认店铺'}</div>
                    {/* <div>店铺描述：{description}</div> */}
                    <div>店铺评分：{score ? <Rate allowHalf defaultValue={score} /> : '暂无评分'}</div>
                    <div>代理等级：{level.title}</div>
                    <div>联系方式：{contactPhoneNo} <a href={`tel:${contactPhoneNo}`}><PhoneOutlined /></a></div>
                </div>
            </Flex>
        </Card>
    )
}